import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import AuthService from '../services/AuthService';
import NotifyService from 'src/services/NotifyService';

const axiosInstance = axios.create({})

const refreshAuthConfig = {
  pauseInstanceWhileRefreshing: true // default: false
}

export default ({ app, router, store, Vue }) => {

  const refreshAuthLogic = failedRequest => AuthService.refreshToken().then(tokenRefreshResponse => {
    const token = tokenRefreshResponse.data.access_token

    store.commit('auth/setToken', { token })

    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + token;
    return Promise.resolve();
  })
  .catch(e => {
    NotifyService.error("Token inválido. Refaça login e tente novamente.")
    return Promise.reject(e)
  });

  createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic, refreshAuthConfig);

  Vue.prototype.$axios = axiosInstance
}
